import { MeetingResponse } from 'lib/api/meetings/types';
import { CovideoGTMMeetingAttributes, GTMMeetingAttributes } from './types';
import { mapDeliveryTimeToGtmMeeting } from '../../utils';

export function mapToGTMMeetingAttributes(
  src?: CovideoGTMMeetingAttributes
): GTMMeetingAttributes {
  if (!src) return {} as GTMMeetingAttributes;

  return {
    meeting_id: src?.meetingId || undefined,
    meeting_title: src?.meetingTitle || undefined,
    invited_participants: src?.invitedParticipants || undefined,
    meeting_url: src?.meetingUrl || undefined,
    meeting_date: src?.meetingDate || undefined,
    meeting_time: src?.meetingTime || undefined,
    meeting_host: src?.meetingHost || undefined,
    crm_participants: src?.crmParticipants || undefined,
  };
}

export const transformMeetingResponseToGTMAttributes = (
  meetingDetails?: MeetingResponse,
  livePageUrl?: string,
  attendeeLimit?: number
): CovideoGTMMeetingAttributes => {
  const { meetingId, title, host, attendees, deliveryTime } =
    meetingDetails || {};

  const { meetingDate: GTMMeetingDate, meetingTime: GTMMeetingTime } =
    mapDeliveryTimeToGtmMeeting(deliveryTime);

  const meetingUrl = meetingId ? livePageUrl + meetingId : undefined;

  return {
    meetingId: meetingId || undefined,
    meetingTitle: title || undefined,
    invitedParticipants: attendeeLimit || undefined,
    meetingUrl: meetingUrl,
    meetingDate: GTMMeetingDate,
    meetingTime: GTMMeetingTime,
    meetingHost: host?.id,
    crmParticipants:
      (attendees ?? []).length > 0
        ? attendees?.map(a => a?.meetingAttendeeID?.toString()).filter(Boolean) // removes null/undefined
        : undefined,
  };
};
